export default function postVerify2FaReducer
  (state = { error:'', success:'', processing:false}, action)
{
  switch (action.type) {
    case 'VERIFY_2FA_SUCCESS':
      return {...state, ...{success: action.success}};

    case 'VERIFY_2FA_ERROR':
      return {...state, ...{error: action.error}};

    case 'VERIFY_2FA_PROCESSING':
      return {...state, ...{processing: action.processing}};

    default: return state;
  }
}